import { render } from "./WalletOrdersTab.vue?vue&type=template&id=3b7129ed&scoped=true"
import script from "./WalletOrdersTab.vue?vue&type=script&lang=js"
export * from "./WalletOrdersTab.vue?vue&type=script&lang=js"

import "./WalletOrdersTab.vue?vue&type=style&index=0&id=3b7129ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7129ed"]])

export default __exports__